import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="my-modal"
export default class extends Controller {
  static values = { turboPath: String }
  connect() {
    this.currentPath = window.location.href

    const options = {
      onShow: () => {
        if (this.turboPathValue) {
          history.pushState(null, null, this.turboPathValue)
        }

      },
      onHide: () => {
        history.replaceState(null, null, this.currentPath)
      }
    }
    this.modal = new Modal(this.element, options)
    this.modal.show()
  }

  disconnect() {
    this.modal.hide()
  }

  close(event) {
    if (event.detail.success) {
      this.modal.hide()
    }
  }
}
